module.exports = __webpack_public_path__ + "img/select1-pc-1.2a82ba6a.png";